import React from "react";
import { Helmet } from 'react-helmet-async';
import { Calendar, ArrowRight, Newspaper } from "lucide-react";
import Header from "./header";
import { generateBreadcrumbJsonLd } from "./utils/breadcrumbJsonLd";

// 静的なお知らせデータ
const newsData = [
  {
    id: 4,
    title: "デザイン設定機能をリリースしました",
    date: "2026/01/15",
    category: "機能追加",
    badge: "NEW",
    badgeColor: "bg-red-100 text-red-800",
    summary: "ダッシュボードからサイトのカラー・ロゴ・デザインスタイルをカスタマイズできる「デザイン設定」機能をリリースしました。プライマリカラー、セカンダリーカラー、背景色、ナビゲーションカラーなどを自由に設定できます。",
    slug: "design-settings-release"
  },
  {
    id: 3,
    title: "友だち招待機能をリリースしました",
    date: "2026/01/12",
    category: "機能追加",
    badge: "",
    badgeColor: "bg-gray-100 text-gray-800",
    summary: "友だちを招待してポイントを獲得できる「友だち招待」機能をリリースしました。紹介者・被紹介者の両方にポイントが付与されます。",
    slug: "friend-referral-release"
  },
  {
    id: 1,
    title: "JOYBASEベータ版がリリースされました",
    date: "2025/10/31",
    category: "リリース",
    badge: "",
    badgeColor: "bg-gray-100 text-gray-800",
    summary: "JOYBASEのベータ版がリリースされました。初期費用0円、月額費用0円でオリパストアを開設できます。",
    slug: "joybase-beta-release"
  }
];

const NewsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>お知らせ | JOYBASE</title>
        <meta name="description" content="JOYBASEからの最新情報・お知らせ一覧です。" />
        <script type="application/ld+json">
        {generateBreadcrumbJsonLd([
          { name: "ホーム", url: "https://www.joybase.jp/" },
          { name: "ニュース", url: "https://www.joybase.jp/news" }
        ])}
        </script>
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Header />

        <div className="pt-20">
          {/* ヘッダー */}
          <div className="bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-400">
            <div className="container mx-auto max-w-4xl px-4 py-10">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-white/90 rounded-xl flex items-center justify-center shadow-sm">
                  <Newspaper className="w-7 h-7 text-yellow-600" />
                </div>
                <div>
                  <h1 className="text-3xl font-bold text-gray-900">お知らせ</h1>
                  <p className="mt-1 text-gray-700">JOYBASEからの最新情報をお届けします</p>
                </div>
              </div>
            </div>
          </div>

          <main className="container mx-auto max-w-4xl px-4 py-8">

            {/* お知らせ一覧 */}
            <div className="space-y-4">
              {newsData.map((news) => (
                <a
                  key={news.id}
                  href={`/news/${news.slug}`}
                  className="block bg-white rounded-lg shadow-sm hover:shadow-md transition p-6"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <span className={`inline-block px-3 py-1 ${news.badgeColor} text-xs font-semibold rounded`}>
                        {news.badge}
                      </span>
                      <span className="text-sm text-gray-500">{news.category}</span>
                    </div>
                    <div className="flex items-center gap-1 text-sm text-gray-500">
                      <Calendar size={14} />
                      {news.date}
                    </div>
                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-2">{news.title}</h2>
                  <p className="text-gray-600 mb-4">{news.summary}</p>

                  <div className="flex items-center gap-1 text-yellow-600 font-medium text-sm">
                    詳しく見る
                    <ArrowRight size={16} />
                  </div>
                </a>
              ))}
            </div>

            {/* 空状態（将来的にページネーション追加時に使用） */}
            {newsData.length === 0 && (
              <div className="bg-white rounded-lg shadow-sm p-12 text-center">
                <p className="text-gray-600">お知らせはまだありません</p>
              </div>
            )}
          </main>
        </div>
      </div>
    </>
  );
};

export default NewsPage;
